import {Cureus} from '../Cureus';

Cureus.Publishing = {
  UserTool: {}
};

//= require_tree ./Publishing
